import React from "react";
import "../css/VisionMission.css";
import asset from '../assets/images'

const VisionMission = () => {
  return (
    <div className="vision-mission-container">
      {/* Vision Section */}
      <div className="vision">
        <div className="vision-image">
          <img src={asset.vission} alt="Vision" />
        </div>
        <div className="vision-text">
          <h2>Our Vision</h2>
          <div className="title-vis-line">
        <span className="vis-dot"></span>
        <span className="vis-line"></span>
        <span className="vis-dot"></span>
      </div>
          <p className="vis-para">
          To be the most trusted and creative wedding photography brand, capturing timeless moments that evoke emotions and preserve love stories for generations.
          </p>
        </div>
      </div>

      {/* Mission Section */}
      <div className="mission">
      <div className="mission-image">
          <img src={asset.mission} alt="Mission" />
        </div>
        <div className="mission-text">
          <h2>Our Mission</h2>
          <div className="title-vis-line">
        <span className="vis-dot"></span>
        <span className="vis-line"></span>
        <span className="vis-dot"></span>
      </div>
          <p className="vis-para">
          Our mission is to create stunning, high-quality wedding photographs that reflect the true essence of each couple’s love story. We strive for excellence through creativity, professionalism, and a personalized approach, ensuring every moment is beautifully documented. With a passion for storytelling, we aim to turn fleeting memories into everlasting treasures.
          </p>
        </div>
        
      </div>
    </div>
  );
};

export default VisionMission;
